import FormattedWeight from './FormattedWeight';

export default FormattedWeight;
